<template>
    <div class="row">
        <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
          <div class="card mb-25 border-0 rounded-0">
            <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
              <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
                <h4 class="position-relative text-black fw-bold mb-10">Détails reclamation</h4>
                <router-link to="/liste-reclamation" 
                class=" btn btn-primary transition border-0 lh-1 fw-medium">
                <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Retour</router-link>
              </div>
              <table class="table">
                <tbody>
                 
                  <tr>
                    <td>Nom:</td>
                    <td>{{ reclamation?.nom}}</td>
                  </tr>
                
                  <tr>
                    <td>Email :</td>
                    <td>{{ reclamation?.email }}</td>
                  </tr>

                  <tr>
                    <td>Objet du message :</td>
                    <td>{{ reclamation?.objet }}</td>
                  </tr>

                  <tr>
                    <td>Message:</td>
                    <td>{{ reclamation?.message }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </div>
  
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref } from "vue";
  import ApiService from "@/services/ApiService";
  import { Reclamation } from "@/models/Reclamation";
  import { error, format_date, showModal } from "@/utils/utils";
  import { useRoute } from "vue-router";
  export default defineComponent({
    name: "ViewReclamation",
    setup: () => {
      const route = useRoute();
      const reclamation = ref<Reclamation | null>(null);
      function getReclamation(id: string) {
        return ApiService.get("/reclamations", id)
          .then(({ data }) => {
            reclamation.value = data.data; 
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      } 
      onMounted(() => {
        const id = route.params.id as string;
        getReclamation(id);
      });
      return { 
        reclamation,
        getReclamation,
        format_date,
       };
    },
  });
  </script>
  